module.exports = __webpack_public_path__ + "img/pack.07f6e4a7.png";